

import { useQuery } from "@tanstack/react-query";
import { abonosXGastos  } from "../../../services";





export const useAbonosXGastos = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ["abonoXgastos", { id }], 
        queryFn: () => abonosXGastos(id),
    });
    
    return { data, isLoading }
}
